import React from "react";
import { Fragment } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { Dialog, Transition } from "@headlessui/react";
import "react-image-gallery/styles/css/image-gallery.css";
import moment from "moment";
import { images } from "../assets/styles/Images";
import RemoteIcon from "./RemoteIcon";
import { useLoggedContext } from "../context/provider";

const NotificationModal = ({ isOpen, setIsOpen, data }) => {
  const { feelingsById, reasonsById } = useLoggedContext();

  // Close Modal
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-50"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-50"
              >
                <Dialog.Panel className="scal w-full max-w-md transform space-y-4 overflow-hidden rounded-2xl bg-white p-10 align-middle shadow-xl transition-all">
                  <div className="flex items-center justify-between">
                    <Dialog.Title as="h3" className="font-poppins text-lg font-semibold leading-7 text-secondary-color">
                      Response
                    </Dialog.Title>
                    <XMarkIcon onClick={closeModal} className="h-8 w-8 cursor-pointer text-grayColor300" />
                  </div>
                  <div className="space-y-4">
                    <div className="flex items-center gap-x-18">
                      <div className="col-span-3">
                        <h2 className="text-base text-grayColor300">Date:</h2>
                      </div>
                      <div>
                        <h2 className="text-lg font-medium text-secondary">{moment.unix(data?.created_date_unix).format("D/MM/YYYY")}</h2>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-7">
                      <div>
                        <h2 className="text-base text-grayColor300">Response: </h2>
                      </div>
                      <div className="flex items-center gap-x-2">
                        {data?.feeling_id == null && (data?.response == null || data?.response === undefined) ? (
                          ""
                        ) : (
                          <RemoteIcon
                            src={feelingsById?.[data?.feeling_id]?.icon_url}
                            alt={feelingsById?.[data?.feeling_id]?.name || data?.response || "feeling"}
                            className="h-6 w-6"
                          />
                        )}

                        <h2 className="text-lg font-medium text-secondary">
                          {feelingsById?.[data?.feeling_id]?.name ||
                            (data?.response == null || data?.response === undefined ? "No Response" : data?.response)}
                        </h2>
                      </div>
                    </div>
                    <div className="flex items-center gap-x-12">
                      <div>
                        <h2 className="text-base text-grayColor300">Reason:</h2>
                      </div>
                      <div className="flex items-center gap-x-2">
                        {data?.reason_id == null && (data?.reason == null || data?.reason === undefined) ? (
                          ""
                        ) : (
                          <RemoteIcon
                            src={reasonsById?.[data?.reason_id]?.icon_url}
                            alt={reasonsById?.[data?.reason_id]?.name || data?.reason || "reason"}
                            className="h-6 w-6"
                          />
                        )}

                        <h2 className="text-lg font-medium text-secondary">
                          {reasonsById?.[data?.reason_id]?.name ||
                            (data?.reason == null || data?.reason === undefined ? "No Reason" : data?.reason)}
                        </h2>
                      </div>
                    </div>
                    <div className="space-y-1">
                      <h2 className="text-left text-base text-grayColor300">Additional Detail:</h2>
                      <p className="text-left text-base font-medium text-secondary">{data?.reason_detail || "N/A"}</p>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default NotificationModal;
